var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('security-page',{scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('page-illustration',{attrs:{"src":_vm.illustration}})]},proxy:true},{key:"right",fn:function(){return [_c('login-form')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }